<template>
    <div class="control-website-block">

        <div v-if="loading" class="control-website-btn">

            <template v-if="user_admin">
                {{ $t('menu.control_pannel') }}
                {{ $t('other.loading') }}
            </template>

        </div>

        <!-- 先檢查是否有註冊 token -->
        <div v-else-if="registed_info != undefined && registed_info.token != undefined" class="control-website-btn">

            <b-button
                variant="danger"
                class="btn-app"
                :href="'https://webapp.yardian.com/validate?token=' + registed_info.token"
                @click="go_To_Page_Log()"
                target="_blank"
            >
                <i class="fa fa-sitemap"></i>
                {{ $t('menu.control_pannel') }}

            </b-button>

            <div class="registed-info-block">

                <div v-if="registed_info.updated_at">
                    {{ $t('menu.updated') }}: {{ registed_info.updated_at }}
                </div>

            </div>

        </div>

        <!-- 沒 token 的話，Admin 才可以進行註冊 -->
        <div v-else-if="user_admin" class="control-website-btn">

            <b-button
                variant="danger"
                class="btn-app"
                @click="register_Control_Account"
                :disabled="loading"
            >
                <b-badge variant="danger">Admin</b-badge>
                {{ $t('menu.register_control_account') }}

            </b-button>

            <div v-if="err_message != undefined" class="registed-info-block">

                註冊失敗

                <b-button

                    variant="outline-danger"
                    class="btn-app-err"
                    @click="show_Err_message"
                >
                    錯誤訊息
                    <i class="fa fa-exclamation-triangle mr-0"></i>

                </b-button>
            </div>

        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        projectID: {
            type: Number,
            required: true,
        },
        timezone: {
            type: String,
            default: 'Asia/Taipei',
        },
    },
    data () {
        return {
            loading: false,
            registed_info: undefined,
            err_message: undefined,
        }
    },
    mounted ()
    {
        this.get_Account_Token()
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
        }),
    },
    watch: {
        projectID ()
        {
            this.get_Account_Token()
        },
    },
    methods: {

        go_To_Page_Log ()
        {
            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'read',
                detail: {
                    page: 'project - control',
                    action: 'enter yardian website',
                    querySettings: {
                        'project ID':   this.projectID,
                        // 'token':        this.registed_info.token,
                        'path':         'https://webapp.yardian.com/validate?token=' + this.registed_info.token,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------

        },

        show_Err_message ()
        {
            let _show_string = `控制帳號註冊失敗(${ this.err_message.data.status })：\n`

            if ( this.err_message.data.message.errors )
            {
                _show_string += `
                errors: ${ JSON.stringify( this.err_message.data.message.errors ) }
                `
            }

            if ( this.err_message.data.message.name )
            {
                _show_string += `
                name: ${ JSON.stringify( this.err_message.data.message.name ) }
                `
            }

            if ( this.err_message.data.message.code )
            {
                _show_string += `
                code: ${ JSON.stringify( this.err_message.data.message.code ) }
                `
            }

            alert( _show_string )
        },

        register_Control_Account ()
        {
            this.loading = true;
            this.err_message = undefined

            const options = {
                method: 'POST',
                url: this.$config.getAPI_URL('API') + 'projects/' + this.projectID + '/yardian_token',
            }
            this.$http(options)
                .then( res => {
                    this.loading = false;
                    this.get_Account_Token()
                })
                .catch( err => {
                    this.loading = false;
                    this.err_message = err
                })

            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'project - control',
                    action: 'register yardian token',
                    querySettings: {
                        'project ID':   this.projectID,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------

        },

        get_Account_Token ()
        {
            this.loading = true;
            this.registed_info = undefined;
            this.err_message = undefined

            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('API') + 'projects/' + this.projectID + '/yardian_token',
            }
            this.$http(options)
                .then( res => {
                    this.loading = false;
                    // console.log( res.data.token_info )

                    this.registed_info = res.data.token_info;
                    if ( this.registed_info != undefined )
                    {
                        if ( this.registed_info.created_at != undefined )   this.registed_info.created_at = this.$tools.date.dateTimeZone( this.registed_info.created_at, this.timezone, 'YYYY-MM-DD HH:mm' )
                        if ( this.registed_info.updated_at != undefined )   this.registed_info.updated_at = this.$tools.date.dateTimeZone( this.registed_info.updated_at, this.timezone, 'YYYY-MM-DD HH:mm' )
                    }

                })
                .catch( err => {
                    this.loading = false;
                    this.registed_info = undefined;
                })
        },

    },
}
</script>

<style lang="scss" scoped>

.control-website-block
{
    display: inline-block;
    vertical-align: top;
}

.control-website-btn
{
    display: inline-block;
    text-align: left;
    // float: right;
    margin: 0px 5px 5px 0px;
}

.btn-app
{
    padding: 5px 15px;
    border-radius: 15px;
    background-color: #bf6613;
    border-color: #bf6613;

    &:hover, &:focus
    {
        border-color: #a45138;
        background-color: #a45138 !important;
    }
}

.registed-info-block
{
    font-size: 1.0rem;
    margin: 5px;

    .btn-app-err
    {
        vertical-align: middle;
        padding: 2px 8px;
        border-radius: 15px;
        margin: 5px;
    }
}

</style>
